<template>
  <div>
    <van-popup
      overlay-class="my-popup"
      class="input-popup"
      v-model="showPopup"
      position="bottom"
      get-container="#app"
      :close-on-click-overlay="false"
    >
      <comment-input
        ref="detail-input"
        :commentsInfo="commentsInfo"
        :id="id"
        :isFavored="isFavored"
        @onCommitEvent="onCommitEvent"
        @onFocusEvent="onFocusEvent"
        @onBlurEvent="onBlurEvent"
      ></comment-input>
      <ad-tip v-if="showAd"></ad-tip>
    </van-popup>
  </div>
</template>
<script>
import { Popup } from 'vant'
import AdTip from '@/views/video/AdTip'
import CommentInput from './CommentInput'
export default {
  name: 'CommentInputPopup',
  data() {
    return {
      showAd: true
    }
  },
  props: {
    commentsInfo: {
      type: Object,
      default: null
    },

    hasPermission: {
      type: Boolean,
      default: false
    },

    // 控制显示收藏icon和传入收藏接口的参数
    id: {
      type: String,
      default: ''
    },
    isFavored: {
      type: Boolean,
      default: false
    },
    showPopup: {
      type: Boolean
    }
  },
  components: {
    AdTip,
    CommentInput,
    'van-popup': Popup
  },
  mounted() {},
  methods: {
    onCommitEvent(content) {
      this.$emit('onCommitEvent', content)
    },

    onFocusEvent() {
      this.showAd = false
    },

    onBlurEvent() {
      this.showAd = true
    }
  }
}
</script>
<style>
.my-popup.van-overlay {
  background-color: transparent;
  height: 120px;
  bottom: 0;
  top: auto;
}
.input-popup {
  border-radius: 0;
}
</style>
